import applicationKeys from "@swa-ui/application/i18nKeys";
import authenticationKeys from "@swa-ui/authentication/i18nKeys";
import { getBootstrapData } from "@swa-ui/bootstrap";
import dotcomKeys from "@swa-ui/dotcom/i18nKeys";
import formKeys from "@swa-ui/form/i18nKeys";
import itineraryKeys from "@swa-ui/itinerary/i18nKeys";
import { setI18nRoot, setLang } from "@swa-ui/locale";
import loyaltyKeys from "@swa-ui/loyalty/i18nKeys";
import personalInfoKeys from "@swa-ui/personal-info/i18nKeys";
import placementsKeys from "@swa-ui/placements/i18nKeys";
import shoppingKeys from "@swa-ui/shopping/i18nKeys";
import vacationsKeys from "@swa-ui/vacations/i18nKeys";

import bookingWidgetsKeys from "../components/BookingWidgets/BookingWidgets.i18n";

const i18nOverrides = getBootstrapData("swa-bootstrap-i18n/i18n-override");

setLang("global");
setI18nRoot({
  global: {
    ...applicationKeys,
    ...authenticationKeys,
    ...dotcomKeys,
    ...formKeys,
    ...itineraryKeys,
    ...loyaltyKeys,
    ...personalInfoKeys,
    ...placementsKeys,
    ...shoppingKeys,
    ...vacationsKeys,
    ...bookingWidgetsKeys,
    ...i18nOverrides?.global,
  },
});
